import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const indicators = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your connection is secure'
    },
    {
      icon: 'Eye',
      title: 'View-Only Access',
      description: 'Designs are protected from download'
    },
    {
      icon: 'Clock',
      title: 'Time-Limited',
      description: 'Link expires automatically'
    },
    {
      icon: 'Lock',
      title: 'Private Preview',
      description: 'Only accessible with your unique link'
    }
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6 elevation-1">
      <div className="text-center mb-6">
        <h3 className="text-lg font-heading text-foreground mb-2">Secure Design Preview</h3>
        <p className="text-sm text-muted-foreground">
          Your exclusive access to custom jewelry designs
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {indicators?.map((indicator, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-muted/30 rounded-lg">
            <div className="w-8 h-8 bg-accent/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={indicator?.icon} size={16} color="var(--color-accent)" />
            </div>
            <div>
              <p className="text-sm font-medium text-foreground">{indicator?.title}</p>
              <p className="text-xs text-muted-foreground mt-0.5">{indicator?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border text-center">
        <div className="flex items-center justify-center space-x-2 text-xs text-muted-foreground">
          <Icon name="Award" size={12} />
          <span>Trusted by luxury jewelry professionals worldwide</span>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;